import { z } from 'zod';
export const stocktakeRowInputSchema = z
    .object({
    rowId: z.string().uuid(),
    version: z.number().int().nonnegative(),
    state: z.enum(['MATCH', 'CORRECT', 'LATER']),
    actualQty: z.number().int().min(0).max(1_000_000).optional(),
})
    .strict()
    .superRefine((input, ctx) => {
    if (input.state === 'CORRECT' && input.actualQty === undefined)
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['actualQty'],
            message: 'actual_required',
        });
});
export const stocktakeActionSchema = z
    .object({
    action: z.enum(['submit', 'approve', 'reject', 'reopen', 'refresh']),
    skuIds: z.array(z.string().uuid()).max(5000).optional(),
})
    .strict();
//# sourceMappingURL=stocktake.js.map